import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router';

import { APP_NAME } from '@/shared/constants';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { setAppNavigate } from '@/shared/services/helpers/navigate-helper';
import MainLoader from '@/shared/ui/main-loader';
import { ErrorFallback } from '@/shared/widgets';
import { useAppSelector } from '@/store';

import { LanguageGuard } from './language.guard';

const AppProvider: React.FC = () => {
  const { navigate } = useAppNavigate();
  const location = useLocation();

  const { headerConfig } = useAppSelector((state) => state.app);
  const { fullscreenCount, fullscreenBlurCount } = useAppSelector(
    (state) => state.loading
  );

  setAppNavigate(navigate);

  useEffect(() => {
    document.title = `${APP_NAME} ${headerConfig.helmetTitle ? `/ ${headerConfig.helmetTitle}` : ''}`;
  }, [headerConfig]);

  return (
    <LanguageGuard>
      <Helmet titleTemplate={`${APP_NAME} / %s`} defaultTitle={APP_NAME}>
        <title>{headerConfig.helmetTitle}</title>
      </Helmet>
      {(fullscreenCount > 0 || fullscreenBlurCount > 0) && (
        <MainLoader fullScreen blur={fullscreenBlurCount > 0} />
      )}
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        resetKeys={[location.pathname]}
      >
        <Outlet />
      </ErrorBoundary>
    </LanguageGuard>
  );
};

export default AppProvider;
